// Generated from record-label-agreement.json at 2025-04-22T03:49:58.368Z

import { atom } from 'jotai';
import { CreedRecordLabelAgreement } from "@quantizr-engineering/common/types/record-label-agreement";


export interface CreedRecordLabelAgreementState {
    loading: boolean;
    data: CreedRecordLabelAgreement[] | null;
    lastFetched: number | null;
  }

export const creedRecordLabelAgreementAtom = atom<CreedRecordLabelAgreementState>({
  loading: false,
  data: [],
  lastFetched: null,
});
